__turbopack_context__.v({
  "button": "DomainDynamic-module__g0N9Pq__button",
  "input": "DomainDynamic-module__g0N9Pq__input",
  "searchBox": "DomainDynamic-module__g0N9Pq__searchBox",
});
